var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeechBubble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "speech-bubble",
    xmlns: "http://www.w3.org/2000/svg",
    width: 79.017,
    height: 70.993,
    viewBox: "0 0 79.017 70.993",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M247.543,100a1.543,1.543,0,1,0,1.543,1.543A1.544,1.544,0,0,0,247.543,100Zm0,0",
    transform: "translate(-208.035 -84.567)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M81.543,263.087A1.543,1.543,0,1,0,80,261.543,1.544,1.544,0,0,0,81.543,263.087Zm0,0",
    transform: "translate(-67.654 -219.873)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M51.855,0c-13.894,0-25.3,9.58-26.179,21.646C12.443,22.309,0,31.851,0,44.756A21.566,21.566,0,0,0,6.019,59.516a9.386,9.386,0,0,1-2.48,8.843A1.543,1.543,0,0,0,4.63,70.993a17.024,17.024,0,0,0,11.795-4.767,35.168,35.168,0,0,0,10.737,1.681c13.892,0,25.294-9.577,26.179-21.641a34.7,34.7,0,0,0,9.251-1.646,17.023,17.023,0,0,0,11.795,4.767,1.543,1.543,0,0,0,1.091-2.635A9.386,9.386,0,0,1,73,37.909,21.566,21.566,0,0,0,79.017,23.15C79.017,9.74,65.615,0,51.855,0ZM27.162,64.82A31.2,31.2,0,0,1,16.589,63a1.543,1.543,0,0,0-1.71.392A13.925,13.925,0,0,1,7.953,67.5a12.482,12.482,0,0,0,.941-9.186,1.54,1.54,0,0,0-.377-.652,18.547,18.547,0,0,1-5.43-12.906c0-10.876,11.025-20.063,24.075-20.063,12.323,0,23.149,8.57,23.149,20.063,0,11.063-10.385,20.063-23.149,20.063ZM70.5,36.056a1.548,1.548,0,0,0-.377.652,12.482,12.482,0,0,0,.941,9.186,13.921,13.921,0,0,1-6.926-4.11,1.544,1.544,0,0,0-1.71-.392,30.4,30.4,0,0,1-9.092,1.783A22.091,22.091,0,0,0,45,27.78h20.13a1.543,1.543,0,0,0,0-3.087H40.255A28.783,28.783,0,0,0,28.77,21.652c.887-10.366,10.9-18.565,23.085-18.565,13.05,0,24.075,9.188,24.075,20.063A18.547,18.547,0,0,1,70.5,36.056Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M140.989,260H121.543a1.543,1.543,0,0,0,0,3.087h19.446a1.543,1.543,0,0,0,0-3.087Zm0,0",
    transform: "translate(-101.48 -219.873)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M107.162,320H81.543a1.543,1.543,0,1,0,0,3.087h25.619a1.543,1.543,0,0,0,0-3.087Zm0,0",
    transform: "translate(-67.654 -270.613)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M306.989,100H287.543a1.543,1.543,0,1,0,0,3.087h19.446a1.543,1.543,0,0,0,0-3.087Zm0,0",
    transform: "translate(-241.862 -84.567)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubble);
export default __webpack_public_path__ + "static/media/SpeechBubble.412f09db7ce1780913ed13679758f49a.svg";
export { ForwardRef as ReactComponent };